import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import ProfileView from "@/views/about/ProfileView.vue";
import SolutionView from "@/views/SolutionView.vue";
import NewsView from "../views/NewsView.vue";
import ContactView from "@/views/ContactView.vue";
import NewsDetail53 from "../views/news/NewsDetail53.vue";
import NewsDetail55 from "../views/news/NewsDetail55.vue";
import NewsDetail56 from "../views/news/NewsDetail56.vue";
import NewsDetail57 from "../views/news/NewsDetail57.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    children: [
      {
        path: "",
        redirect: "profile",
      },
      {
        path: "profile",
        name: "profile",
        component: ProfileView,
      },
      {
        path: "culture",
        name: "culture",
        component: () => import("@/views/about/CultureView.vue"),
      },
      {
        path: "history",
        name: "history",
        component: () => import("@/views/about/HistoryView.vue"),
      },
      {
        path: "honors",
        name: "honors",
        component: () => import("@/views/about/HonorsView.vue"),
      },
      {
        path: "partners",
        name: "partners",
        component: () => import("@/views/about/PartnersView.vue"),
      },
    ],
  },
  {
    path: "/solutions",
    name: "solutions",
    component: SolutionView,
  },
  {
    path: "/news",
    name: "news",
    component: NewsView,
  },
  {
    path: "/news/53",
    name: "NewsDetail53",
    component: NewsDetail53,
  },
  {
    path: "/news/55",
    name: "NewsDetail55",
    component: NewsDetail55,
  },
  {
    path: "/news/56",
    name: "NewsDetail56",
    component: NewsDetail56,
  },
  {
    path: "/news/57",
    name: "NewsDetail57",
    component: NewsDetail57,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // 如果有 hash，等待 DOM 更新后滚动到对应位置
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            const offset = 192; // 与组件中使用的 offset 保持一致
            const top =
              element.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
              top,
              behavior: "smooth",
            });
          }
          resolve();
        }, 100);
      });
    } else if (savedPosition) {
      // 如果有保存的位置，使用保存的位置
      return savedPosition;
    } else {
      // 其他情况滚动到顶部
      return { x: 0, y: 0 };
    }
  },
});

// 添加全局路由错误处理
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
